'use client';

export const RECORD_PAGE_SIZE = 20;

export function pageWindow<T>(rows: T[], page: number): { rows: T[]; page: number; pages: number } {
  const pages = Math.max(1, Math.ceil(rows.length / RECORD_PAGE_SIZE));
  const safePage = Math.min(Math.max(1, page), pages);
  const start = (safePage - 1) * RECORD_PAGE_SIZE;
  return { rows: rows.slice(start, start + RECORD_PAGE_SIZE), page: safePage, pages };
}

export function RecordPager({
  page,
  pages,
  total,
  onPage,
}: {
  page: number;
  pages: number;
  total: number;
  onPage: (page: number) => void;
}) {
  if (total < 0) return null;
  return (
    <div className="flex items-center justify-between rounded-2xl border border-line bg-card px-3 py-2 text-xs">
      <p className="font-semibold text-muted">
        Page {page} of {pages} · {total} records
      </p>
      <div className="flex gap-2">
        <button type="button" disabled={page <= 1} onClick={() => onPage(page - 1)} className="rounded-xl border border-line px-3 py-1.5 font-bold text-ink disabled:opacity-40">
          Previous
        </button>
        <button type="button" disabled={page >= pages} onClick={() => onPage(page + 1)} className="rounded-xl border border-line px-3 py-1.5 font-bold text-ink disabled:opacity-40">
          Next
        </button>
      </div>
    </div>
  );
}
